import { render } from "./CtaOverlayComponent.vue?vue&type=template&id=74d8844e&scoped=true"
import script from "./CtaOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./CtaOverlayComponent.vue?vue&type=script&lang=ts"

import "./CtaOverlayComponent.vue?vue&type=style&index=0&id=74d8844e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74d8844e"

export default script